import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

/**
 * Franja hero común debajo del menú global (sin logo duplicado: el logo va en PublicLayout).
 */
const PortalProveedorPageHeader = ({ title, subtitle, children }) => {
  return (
    <div
      style={{
        backgroundImage:
          'linear-gradient(115deg, rgba(43, 62, 83, 0.92) 0%, rgba(43, 62, 83, 0.75) 45%, rgba(52, 152, 219, 0.35) 100%), url(/fondo.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '1.75rem 0',
        boxShadow: '0 4px 14px rgba(0,0,0,0.12)',
      }}
    >
      <Container>
        <Row className="align-items-center g-3">
          <Col xs={12} md={children ? 7 : 12}>
            <h1 className="text-white mb-1 fw-bold" style={{ fontSize: 'clamp(1.25rem, 2.5vw, 1.65rem)' }}>
              {title}
            </h1>
            {subtitle && (
              <p className="text-white mb-0 small" style={{ opacity: 0.9 }}>
                {subtitle}
              </p>
            )}
          </Col>
          {children && (
            <Col xs={12} md={5} className="text-md-end">
              {children}
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
};

export default PortalProveedorPageHeader;
